/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import classnames from 'classnames';
import {
  Button,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  ModalFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import MainCGM from './subComponents/MainCGM';
import './subComponents/styles.css';
import ManagerCGM from './subComponents/ManagerCGM';
import AddComponent from './subComponents/AddComponent';
// eslint-disable-next-line import/order
import { useDispatch, useSelector } from 'react-redux';
import SupportCGM from './subComponents/SupportCGM';
import CompaniesCGM from './subComponents/CompaniesCGM';
import AdminsCGM from './subComponents/AdminsCGM';
import { getCompanyNumbers } from '../../actions/Numbers';
import { getEnterpriseGroupUser } from '../../actions/Users';
import { getCompanyGroupManager, getSupportEngineers } from '../../actions/Companies';
import './CompanyGroupManager.css';
import TAB_OPTION from './helper';
import MainEnterprise from './subComponents/MainEnterprise';

const groupItems = [
  // { label: '', value: '' },
  { label: 'CSG', value: 'CSG' },
  { label: 'Granite', value: 'Granite' },
  { label: 'Bullseye', value: 'Bullseye' },
];
const errors = {
  users: 'This user is already added in list!',
  companies: 'This company is already in this management group.',
};
const EnterpriseGroupManagement = ({ onCancel, onConfirm }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;

  const editCompanyGroup = useSelector(state => state.UIState.companies.editEnterpriseGroupData);

  const companies =
    useSelector(state => state.AppState.companies)?.docs?.map(company => ({
      ...company,
      email: company.name,
    })) || [];

  const [selected, setSelected] = useState('main');
  const [selectedList, setSelectedList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [adminSelectedList, setAdminSelectedList] = useState([]);
  const [companySelectedList, setCompanySelectedList] = useState([]);
  const [companyBoxesIDs, setBoxesIDs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [state, setState] = useState({
    hostTag: {},
    name: '',
    company: {},
  });

  const getEnterpriseUsers_ = useCallback(async () => {
    setLoading(true);
    const suggestion = {
      _id: editCompanyGroup.managementCompany._id,
      name: editCompanyGroup.managementCompany.name,
    };

    const users = await dispatch(
      getEnterpriseGroupUser(token, editCompanyGroup._id)
    );

    setUserList(users);
    setLoading(false);

    return users;
  }, [editCompanyGroup]);

  const getInitialSelected = useCallback(
    async selected_ => {
      let userDraft = [...(userList?.length ? [userList] : [])];

      if (!userDraft?.length && selected_ === TAB_OPTION.USERS) {
        const draft = await getEnterpriseUsers_();
        if (draft?.emails?.length) {
          userDraft = [...draft.emails];
        }
      }

      switch (selected_) {
        case TAB_OPTION.USERS:
          return userDraft;
        case TAB_OPTION.COMPANIES:
          return companies;
        default:
          return [];
      }
    },
    [selected, editCompanyGroup, userList, editCompanyGroup],
  );

  const onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const groupAdminsList = await dispatch(
      getCompanyNumbers(token, suggestion._id, false, 'companyGroupAdmin', true),
    );

    setUserList(groupAdminsList);
  };
  useEffect(() => {
    if (editCompanyGroup) {
      setAdminSelectedList(editCompanyGroup.memberUsers);
      setCompanySelectedList(editCompanyGroup.memberCompanies);
      setBoxesIDs(editCompanyGroup.boxes);
      const defaultState = {
        hostTag: editCompanyGroup.hostTag ? { value: editCompanyGroup.hostTag } : {},
        name: editCompanyGroup.name ?? '',
        company: editCompanyGroup.managementCompany
          ? { value: editCompanyGroup.managementCompany._id }
          : {},
      };
      setState(defaultState);
    }
  }, [editCompanyGroup]);

  const handleEditCompanyGroupCallMethod = useCallback(async e => {
    const val_ = await getInitialSelected(e);
    const shallowClone = val_?.length ? [...val_] : [];
    setSelectedList(shallowClone);
  }, []);

  const onInputChange = e => {
    if (e) setSelectedValue(e.suggestion);
  };

  const onTabChange = useCallback(async e => {
    setSelected(e);
    setSelectedValue('');
    await handleEditCompanyGroupCallMethod(e);
  }, []);

  const onAddButtonClick = () => {
    let selectedItem;

    switch (selected) {
      case 'users':
        selectedItem = adminSelectedList.find(item => item?.email === selectedValue?.email);
        break;
      default:
        console.log({ companySelectedList });
        selectedItem = companySelectedList.find(item => item._id === selectedValue._id);
        break;
    }

    if (!selectedItem) {
      switch (selected) {
        case 'users':
          setAdminSelectedList([...adminSelectedList, selectedValue]);
          break;
        default:
          setCompanySelectedList([...companySelectedList, selectedValue]);
          break;
      }

      setSelectedValue('');
    } else {
      toast.error(errors[selected]);
    }
  };

  const onDelete = data => {
    let newList;
    switch (selected) {
      case 'users':
        newList = adminSelectedList.filter(item => item.email !== data.email);
        setAdminSelectedList(newList);
        break;
      default:
        newList = companySelectedList.filter(item => item._id !== data._id);
        setCompanySelectedList(newList);
        break;
    }
  };

  const onStateChange = (value, key) => {
    if (key === 'company') {
      onAddedCompanyChange({
        name: value.label,
        value: value.value,
        suggestion: { _id: value.value, name: value.label },
      });
    }
    setState(s => {
      return {
        ...s,
        [key]: value,
      };
    });
  };

  const submit = () => {
    const memberUsers = adminSelectedList.reduce((acc, item) => {
      acc.push(item._id);
      return acc;
    }, []);
    const memberCompanies = companySelectedList.reduce((acc, item) => {
      acc.push(item._id);
      return acc;
    }, []);

    onConfirm({
      ...state,
      managementCompany: state.company?.value || '',
      hostTag: state.hostTag?.value || '',
      memberUsers,
      memberCompanies,
    });
  };

  return (
    <>
      <div>
        <Row>
          <Col sm={6}>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'main' })}
                  onClick={() => onTabChange('main')}
                >
                  Main
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'companies' })}
                  onClick={() => onTabChange('companies')}
                >
                  Member Companies
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'users' })}
                  onClick={() => onTabChange('users')}
                >
                  Enterprise Users
                </NavLink>
              </NavItem>
            </Nav>
          </Col>

          <Col sm={6}>
            {['users', 'companies'].includes(selected) && (
              <AddComponent
                onClick={onAddButtonClick}
                searchTerm="email"
                dropdownList={selectedList || []}
                isDisabled={false}
                placeholder={`Search ${selected}...`}
                onChange={onInputChange}
                value={selectedValue || {}}
                name={selected}
                loading={loading}
                onKeyDown={false}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col className="scroll-bar-highted" sm={12}>
            <TabContent activeTab={selected}>
              <TabPane tabId="main">
                {selected === 'main' && (
                  <MainEnterprise
                    groupItems={groupItems}
                    state={state}
                    onStateChange={onStateChange}
                  />
                )}
              </TabPane>
              <TabPane tabId="users">
                {selected === 'users' && (
                  <AdminsCGM
                    seletedAdmins={adminSelectedList}
                    loading={loading}
                    onDelete={onDelete}
                  />
                )}
              </TabPane>

              <TabPane tabId="companies">
                {selected === 'companies' && (
                  <CompaniesCGM
                    seletedCompanies={companySelectedList}
                    loading={loading}
                    onDelete={onDelete}
                    boxesData={companyBoxesIDs}
                  />
                )}
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Close
        </Button>

        <Button color="primary" onClick={submit}>
          Submit
        </Button>
      </ModalFooter>
    </>
  );
};

export default EnterpriseGroupManagement;
